import React, {Component, ReactNode} from 'react'
import styled from 'styled-components'
import {MainContainer} from '../../../styledComponents/ContentsArea'
import {currentMedia, HideInSP} from '../../../styledComponents/ResponsiveConvenience'
import {Nullable} from '../../../app/TypeHelpers'
import {Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'
import {NoWrapSpan} from '../../../components/assocDirector/shared/AssocComponents'
import {formatNumberWithCommas} from '../../../formatters/formatNumberWithCommas'
import {formatDateSlashSeparator} from '../../../formatters/formatDate'
import {LOGIN_MODE} from '../../../CodeMaster'
import MessageDialogComponent from '../../../common/resident/MessageDialogComponent'
import {Messages} from '../../../Messages'
import {NatGetSmileagePointResponseBean} from '../residentUser/repository/NatGetSmileagePoint'
import {faExternalLinkAlt} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {NavigateFunction} from 'react-router-dom'

interface Props {
    getSmileagePointResponse: NatGetSmileagePointResponseBean
    loginMode: Nullable<string>
    navigate: NavigateFunction
}

interface State {
    openOperationNotAvailableToAdminDialog: boolean
}

class NatSmileagePointComponent extends Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
            openOperationNotAvailableToAdminDialog: false,
        }
    }

    // 管理者操作不可のダイアログを閉じる
    handleCloseOperationNotAvailableToAdminDialog = () => {
        this.setState({openOperationNotAvailableToAdminDialog: false})
    }

    // 長谷工ID登録に進む
    private handleRegisterHasekoIdButtonClick = () => {
        this.props.navigate(`/resident/hasekoIdRegistration`)
    }

    // 住まいレージポイントを使う（外部サイト（ブランシエラクラブ）に遷移）
    private handleUseSmileagePointButtonClick = () => {
        this.setState({openOperationNotAvailableToAdminDialog: true})
    }

    private renderSmileageRegisterHasekoId(): ReactNode {
        return <>
            <SmileagePointContentArea>
                <NotRegistrationSmileagePointText>
                    長谷工IDをご登録いただくとお得な住まいレージポイントサービスをご利用できます<br/>
                    特別に <PresentPointText>3,000</PresentPointText> ポイントプレゼント！！
                </NotRegistrationSmileagePointText>
            </SmileagePointContentArea>
            <SmileagePointLink onClick={this.handleRegisterHasekoIdButtonClick}>
                <SmileagePointLinkText>無料登録</SmileagePointLinkText>
            </SmileagePointLink>
        </>
    }

    private renderSmileagePoint(): ReactNode {
        const {
            smileagePoint,
            expiringSmileagePoint,
            expiryDate,
        } = this.props.getSmileagePointResponse

        return <>
            <SmileagePointContentArea>
                <SmileagePointArea>
                    <SmileagePointText><NoWrapSpan>保有スマイル</NoWrapSpan></SmileagePointText>
                    <HideInSP>
                        <SmileagePointText>：</SmileagePointText>
                    </HideInSP>
                    <SmileArea>
                        <SmileagePointText>
                            {smileagePoint !== null
                                ? formatNumberWithCommas(smileagePoint)
                                : 'ー'
                            }
                        </SmileagePointText>
                    </SmileArea>
                </SmileagePointArea>
                <ExpiringSmileagePointArea>
                    <ExpiringSmileagePointText>
                        <NoWrapSpan>失効</NoWrapSpan>
                        {expiryDate &&
                            <NoWrapSpan>({formatDateSlashSeparator(expiryDate)})</NoWrapSpan>}
                    </ExpiringSmileagePointText>
                    <HideInSP>
                        <ExpiringSmileagePointText>：</ExpiringSmileagePointText>
                    </HideInSP>
                    <SmileArea>
                        <ExpiringSmileagePointText>
                            {expiringSmileagePoint !== null
                                ? formatNumberWithCommas(
                                    expiringSmileagePoint
                                )
                                : 'ー'
                            }
                        </ExpiringSmileagePointText>
                    </SmileArea>
                </ExpiringSmileagePointArea>
            </SmileagePointContentArea>
            <SmileagePointExternalLinkIcon icon={faExternalLinkAlt}/>

        </>
    }

    private renderUseButton = () => {
        if (this.props.loginMode === LOGIN_MODE.ADMIN.value) {
            this.handleUseSmileagePointButtonClick();
            return;
        } else {
            window.open('https://www.haseko.co.jp/branchera/smile/index.html', '_blank')
        }
    }

    private renderOperationNotAvailableToAdminDialog(): ReactNode {
        return (
            <MessageDialogComponent
                open={this.state.openOperationNotAvailableToAdminDialog}
                params={{
                    title: '確認',
                    errorLevel: Messages.ISYCR0001.errorLevel,
                    message: Messages.ISYCR0001.toString(),
                    buttonProps: [
                        {
                            isDefault: false,
                            buttonLabel: 'OK',
                            buttonHandler: this.handleCloseOperationNotAvailableToAdminDialog,
                        },
                    ],
                }}
            />
        )
    }

    render(): ReactNode {
        const {
            showSmileagePoint,
        } = this.props.getSmileagePointResponse

        let smileageComponent: ReactNode

        if (!showSmileagePoint) {
            smileageComponent = this.renderSmileageRegisterHasekoId()
        } else {
            smileageComponent = this.renderSmileagePoint()
        }

        return <>
            <SmileagePointContainer
                onClick={this.renderUseButton}
                style={{cursor: 'pointer'}}
            >
                <SmileagePointIcon
                    src={'/resources/images/icons/smileage.svg'}
                    alt={'住まいレージロゴ'}
                />
                {smileageComponent}
            </SmileagePointContainer>
            {this.renderOperationNotAvailableToAdminDialog()}
        </>
    }
}

export default NatSmileagePointComponent

const SmileagePointContainer = styled(MainContainer)`
    padding: 11.5px 15px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    box-shadow: 0px 3px 3px darkgray;
    margin-right: 20px;

    ${currentMedia.lessThan('sp')`
        padding: 10px;
        margin-right: 6px;
  `}
`

const SmileagePointIcon = styled.img`
    margin-right: 20px;
    height: 37px;

    ${currentMedia.lessThan('sp')`
        margin-right: 5px;
        height: 35px;
  `}
`

const SmileagePointContentArea = styled.div`
    gap: 20px;
    display: flex;
    align-items: baseline;
    flex-grow: 1;

    ${currentMedia.lessThan('sp')`
        gap: 5px;
        flex-direction: column;
  `}
`

const NotRegistrationSmileagePointText = styled.div`
    font-size: ${FontSize.Small};

    ${currentMedia.lessThan('sp')`
        font-size: 10px;
   `}
`

const PresentPointText = styled.span`
    font-size: ${FontSize.Accent};
    font-weight: ${FontWeights.Bold};
    color: ${Colors.Primary};

    ${currentMedia.lessThan('sp')`
        font-size: ${FontSize.Body};
   `}
`

const SmileagePointLink = styled.a<{ disabled?: boolean }>`
    font-size: ${FontSize.Middle};
    display: flex;
    align-items: center;
    padding: 6px 16px;

    background-color: ${Colors.Surface};
    white-space: nowrap;
    text-decoration: none;

    border: 1px solid;
    border-radius: 4px;
    border-color: ${Colors.Primary};
    color: ${Colors.Primary};
    cursor: pointer;

    ${props => props.disabled && `
        border-color: ${Colors.AccentLight};
        color: ${Colors.AccentLight};
        cursor: default;
   `}

    ${currentMedia.lessThan('sp')`
        padding: 4.5px 10px;
   `}
`

const SmileagePointLinkText = styled.div`
    font-size: ${FontSize.Middle};

    ${currentMedia.lessThan('sp')`
        font-size: 10.5px;
   `}
`

const SmileagePointArea = styled.div`
    font-weight: ${FontWeights.Bold};
    display: flex;
    align-items: baseline;

    ${currentMedia.lessThan('sp')`
        width: 100%;
        justify-content: space-between;
   `}
`

const SmileagePointText = styled.div`
    margin-right: 5px;
    font-size: ${FontSize.Body};

    ${currentMedia.lessThan('sp')`
        font-size: ${FontSize.Middle};
   `}
`

const ExpiringSmileagePointArea = styled.div`
    font-size: ${FontSize.Small};
    display: flex;
    align-items: baseline;

    ${currentMedia.lessThan('sp')`
        width: 100%;
        justify-content: space-between;
   `}
`

const ExpiringSmileagePointText = styled.div`
    margin-right: 5px;

    ${currentMedia.lessThan('sp')`
        font-size: 10px;
   `}
`

const SmileagePointExternalLinkIcon = styled(FontAwesomeIcon)`
    margin-right: -4px;
    font-size: 10px;
    margin-top: 7px;

    ${currentMedia.lessThan('sp')`
        font-size: 13px;
        margin-right: -2px;
   `}
`

const SmileArea = styled.span`
    display: flex;
    align-items: baseline;
`

const SmileUnitText = styled.span`
    font-size: ${FontSize.Small};

    ${currentMedia.lessThan('sp')`
        font-size: 10px;
   `}
`
